module.exports = __webpack_public_path__ + "static/media/order_complete.0c165ba1.png";